var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:({ width: _vm.iconSize, height: _vm.iconSize }),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }